import React, { useEffect } from 'react'
import { Platform } from 'react-native'

import { createParam } from 'solito'
import { useRouter } from 'solito/router'

type UsePaginationType = {
  disableScroll?: boolean
  pathname?: string
  scrollTo?: () => void
}

const { useParam } = createParam()

const usePagination = ({
  disableScroll,
  pathname = '',
  scrollTo
}: UsePaginationType) => {
  const router = useRouter()
  const isWeb = Platform.OS === 'web'

  const [p = ''] = useParam('p')

  const [page, setSimplePage] = React.useState<number>(() => Number(p) || 1)

  const setPage = (value: number) => {
    if (!disableScroll) {
      if (isWeb) window.scrollTo(0, 0)
    }

    if (pathname) {
      const enableScroll = !scrollTo

      router.push(
        {
          pathname: pathname,
          query: { p: value }
        },
        undefined,
        { scroll: enableScroll }
      )
    }
    setSimplePage(value)

    if (scrollTo) scrollTo()
  }

  useEffect(() => {
    setSimplePage(Number(p) || 1)
  }, [p])

  return { setPage, page: page || 1 }
}

export default usePagination
